import * as fromDatatype from '../datatype-library/index';

export interface app_user_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_ref_guid: fromDatatype.GuidDataFieldInterface;
  app_master_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  audit_type: fromDatatype.VarcharDatatypeInterface;
  audit_level: fromDatatype.VarcharDatatypeInterface;
  event_type: fromDatatype.VarcharDatatypeInterface;
  location: fromDatatype.VarcharDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  foreign_table1: fromDatatype.VarcharDatatypeInterface;
  foreign_key1: fromDatatype.VarcharDatatypeInterface;
  foreign_table2: fromDatatype.VarcharDatatypeInterface;
  foreign_key2: fromDatatype.VarcharDatatypeInterface;
  time_log: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_user_audit_trail_RowClass implements app_user_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_ref_guid: fromDatatype.GuidDataFieldInterface;
  app_master_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  audit_type: fromDatatype.VarcharDatatypeInterface;
  audit_level: fromDatatype.VarcharDatatypeInterface;
  event_type: fromDatatype.VarcharDatatypeInterface;
  location: fromDatatype.VarcharDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  foreign_table1: fromDatatype.VarcharDatatypeInterface;
  foreign_key1: fromDatatype.VarcharDatatypeInterface;
  foreign_table2: fromDatatype.VarcharDatatypeInterface;
  foreign_key2: fromDatatype.VarcharDatatypeInterface;
  time_log: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


